import { emoji } from '@/framework/directive'
import request from '@/utils/request'

function validNameLength(rule, value, callback) {
  if (value.length > 20) {
    callback(new Error('内容长度为20'))
  } else {
    callback()
  }
}
function validateTel(rule, value, callback) {
  if (!/^[\d-]*$/g.test(value)) {
    callback(new Error('手机号码填写11位数字，座机号码填写 “区号-电话号码”'))
  } else {
    callback()
  }
}
export default function () {
  const storeInfo_formConfig = [
    {
      el: 'input',
      itemConfig: {
        label: '门店名称',
        prop: 'name',
      },
      elConfig: {
        clearable: false,
        maxlength: 20,
        request,
        render: 'QSCheckTextInput',
        style: {
          width: '188.5px',
        },
        placeholder: '请输入门店名称',
        events: {
          input: (e) => {
            this.$set(this.storeInfo_model, 'name', emoji(e))
          },
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '联系电话',
        prop: 'contactTel',
      },
      render: () => {
        const $h = this.$createElement
        return $h(
          'el-form-item',
          {
            props: {
              label: '联系电话',
              prop: 'contactTel',
            },
          },
          [
            $h(
              'template',
              { slot: 'label' },
              [
                $h(
                  'span',
                  null,
                  [
                    '联系电话',
                    $h(
                      'el-tooltip',
                      {
                        class: 'item',
                        props: {
                          effect: 'dark',
                          placement: 'top',
                        },
                      },
                      [
                        $h(
                          'i',
                          {
                            class: 'el-icon-question',
                            style: 'font-size: 16px; vertical-align: bottom;',
                          },
                        ),
                        $h(
                          'div',
                          { slot: 'content' },
                          [
                            $h('p', null, '当前电话为租车商城唯一联系电话，请谨慎填写'),
                          ],
                        ),
                      ],
                    ),
                  ],
                ),
              ],
            ),
            $h(
              'el-input',
              {
                style: {
                  width: '188.5px',
                },
                props: {
                  value: this.storeInfo_model.contactTel,
                },
                attrs: {
                  placeholder: '请输入手机号',
                },
                on: {
                  input: (value) => {
                    this.storeInfo_model.contactTel = value.slice(0, 13)
                  },
                },
              },
            ),
          ],
        )
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '省份',
        prop: 'provinceCode',
      },
      elConfig: {
        filterable: true,
        events: {
          change: this.handleProvince,
        },
        options: {
          label: 'provinceName',
          value: 'provinceCode',
          list: [],
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '门店城市',
        prop: 'cityCode',
      },
      elConfig: {
        filterable: true,
        disabled: true,
        loading: false,
        options: {
          label: 'cityName',
          value: 'cityCode',
          list: [],
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '地址',
        prop: 'address',
      },
      elConfig: {
        remote: true,
        filterable: true,
        reserveKeyword: true,
        defaultFirstOption: true,
        placeholder: '请输入关键字',
        disabled: true,
        remoteMethod: (query) => {
          this.getStoreList(query)
        },
        elRender: (data) => {
          return `<span style="float: left; color: #909399; font-size: 12px">${data.address}</span>
          <span style="float: right; color: #909399; font-size: 12px">${data.district}</span>`
        },
        options: {
          label: 'address',
          value: 'location', // 经纬度
          list: [],
        },
      },
    },
    {
      el: 'checkbox',
      itemConfig: {
        label: '司机到店所需证件',
        prop: 'needLicenseType',
      },
      elConfig: {
        options: {
          label: 'label',
          value: 'value',
          list: [
            {
              label: '身份证',
              value: 10,
              disabled: true,
            },
            {
              label: '驾驶证',
              value: 20,
              disabled: true,
            },
            {
              label: '银行卡',
              value: 30,
              disabled: true,
            },
            {
              label: '网约车驾驶证',
              value: 40,
            },
          ],
        },
      },
    },
    {
      el: 'upload',
      itemConfig: {
        label: '企微二维码',
        prop: 'contactQRCode',
      },
      elConfig: {
        render: 'UploadCommon',
        listType: 'img',
        fileList: [],
        customSize: 3,
        fileTitle: '支持PNG、JPG、JPEG格式，最多上传一张',
        fileTitleWidth: '320px',
        commonUpload: true,
        group: 'assert',
        code: 'assert_person_file',
      },
    },
  ]
  const storeInfo_formRule = {
    name: [
      { required: true, message: '请输入门店名称', trigger: 'blur' },
      { required: true, validator: validNameLength, trigger: 'blur' },
    ],
    contactTel: [
      { required: true, message: '请输入联系电话', trigger: 'blur' },
      { required: true, validator: validateTel, trigger: 'blur' },
    ],
    provinceCode: [
      { required: true, message: '请选择省份', trigger: 'change' },
    ],
    cityCode: [
      { required: true, message: '请选择城市', trigger: 'change' },
    ],
    address: [
      { required: true, message: '请选择门店地址' },
    ],
    needLicenseType: [
      { required: false, message: '请选择所需证件', trigger: 'change' },
    ],
  }
  const storeInfo_model = {
    name: '',
    contactTel: '',
    provinceCode: '',
    cityCode: '',
    address: '',
    needLicenseType: [10, 20, 30, 40],
    contactQRCode: '',
  }
  const columns = [
    {
      name: 'name',
      columnProps: {
        label: '租赁方案名称',
        prop: 'name',
      },
    },
    {
      name: 'rentPeriod',
      columnProps: {
        label: '租赁周期',
        prop: 'rentPeriod',
      },
    },
    {
      name: 'rentAmount',
      columnProps: {
        label: '月租金',
        prop: 'rentAmount',
      },
    },
    {
      name: 'deposit',
      columnProps: {
        label: '押金（元）',
        prop: 'deposit',
      },
    },
    {
      name: 'billDay',
      columnProps: {
        label: '缴款日',
        prop: 'billDay',
      },
    },
    {
      name: 'presentDays',
      columnProps: {
        label: '赠送天数（天）',
        prop: 'presentDays',
      },
    },
  ]
  return {
    storeInfo_formConfig,
    storeInfo_formRule,
    storeInfo_model,
    columns,
  }
}
